import React from 'react';
import moment from 'moment';
import * as PropTypes from 'prop-types';

import { COLORS } from '../../../constants/styles';
import Button from '../../Button';
import Icon from '../../Icon';
import { computeDistanceBetweenLocations, currentWorkingHours } from '../utils';
import { WorkingHoursView } from './WorkingHoursView';
import styles from './index.styl';

export function LocationDetailsView({
  formatMessage,
  myGeoLocation,
  isMyPosition,
  location,
  opened,
  onClose,
  isAppointment,
  startTime,
}) {
  const schedule = location ? location.schedule : {};
  const delta = isMyPosition
    ? computeDistanceBetweenLocations(myGeoLocation, location)
    : '';
  const workingHours = currentWorkingHours(
    formatMessage,
    schedule,
    false,
    true,
  );
  const description = `${delta}${formatMessage({ id: 'googleMaps.miAway' })}`;

  return (
    opened && (
      <div className={styles.root}>
        <div className={styles.headerPopup}>
          <div className={styles.titleLocation}>
            {location ? location.name : ''}
            <Button icon onClick={onClose} className={styles.closeBtn}>
              <Icon
                name="ico-24-close"
                size={16}
                style={{ fill: COLORS.stormyBlue }}
              />
            </Button>
          </div>
          {isMyPosition && (
            <div className={styles.description}>{description}</div>
          )}
          <div className={styles.divider} />
        </div>
        <div className={styles.wrapper}>
          <div className={styles.title}>
            {formatMessage({ id: 'googleMaps.location' })}
          </div>
          <div className={styles.description}>
            {isAppointment
              ? location && location.address && location.city
                ? `${location.address}, ${location.city}`
                : '-'
              : location && location.address
              ? location.address
              : '-'}
          </div>
          <div className={styles.divider} />
        </div>
        <div className={styles.wrapper}>
          <div className={styles.title}>
            {formatMessage({ id: 'common.phone' })}
          </div>
          <div className={styles.description}>
            {location && (location.phoneNumber || location.phone)
              ? location.phoneNumber || location.phone
              : '-'}
          </div>
          <div className={styles.divider} />
        </div>
        <div className={styles.wrapper}>
          {!isAppointment ? (
            <WorkingHoursView
              schedule={schedule}
              currentWorkingHours={workingHours}
              formatMessage={formatMessage}
            />
          ) : (
            <React.Fragment>
              <div className={styles.title}>
                {formatMessage({ id: 'dashboard.record.visitTime.map' })}
              </div>
              <div>{moment(startTime).format('D MMM, YYYY h:mm A')}</div>
            </React.Fragment>
          )}
          {!isAppointment && <div className={styles.divider} />}
        </div>
        {!isAppointment && (
          <div className={styles.wrapper}>
            <div className={styles.title}>
              {formatMessage({ id: 'googleMaps.about' })}
            </div>
            <div className={styles.description}>
              {location && location.description ? location.description : '-'}
            </div>
          </div>
        )}
      </div>
    )
  );
}

LocationDetailsView.propTypes = {
  formatMessage: PropTypes.func,
  location: PropTypes.object,
  opened: PropTypes.bool,
  onClose: PropTypes.func,
  myGeoLocation: PropTypes.object,
  isMyPosition: PropTypes.bool,
  isAppointment: PropTypes.bool,
  startTime: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/LocationDetailsPopUp/index.jsx